import React from 'react'
import { Table, Form } from '_zari/core'

import { TiposTablaPersonalizadaConstant } from 'constants/index'
import * as TablasPersonalizadasService from 'services/tablasPersonalizadas.service'

import * as Rows from './rows'

const DetallesTable = ({ detalles, dispatch }) => {
  const [filtroProducto, setFiltroProducto] = React.useState('')
  const [filtroOficinaId, setFiltroOficinaId] = React.useState('')

  const [oficinas, setOficinas] = React.useState([])

  React.useEffect(() => {
    TablasPersonalizadasService.getAsSelect(TiposTablaPersonalizadaConstant.OFICINA)
      .then(({ data }) => setOficinas(data || []))
      .catch(() => setOficinas([]))
  }, [])

  const nombreOficinaSeleccionada = React.useMemo(() => {
    if (!filtroOficinaId) return ''
    const match = oficinas.find(x => x._id === filtroOficinaId)
    return match ? match.nombre || '' : ''
  }, [filtroOficinaId, oficinas])

  const detallesFiltrados = React.useMemo(() => {
    const text = (filtroProducto || '').trim().toUpperCase()
    const oficinaId = (filtroOficinaId || '').trim()
    const oficinaNombre = (nombreOficinaSeleccionada || '').trim().toUpperCase()

    return (detalles || []).filter(row => {
      if (text) {
        const nombre = `${row?.nombreProducto || ''}`.toUpperCase()
        if (!nombre.includes(text)) return false
      }

      if (oficinaId) {
        const idRow = `${row?._idOficinaSolicitante || ''}`.trim()
        const nombreRow = `${row?.oficinaSolicitante || ''}`.trim().toUpperCase()

        if (idRow) {
          if (idRow !== oficinaId) return false
        } else {
          if (!oficinaNombre) return false
          if (nombreRow !== oficinaNombre) return false
        }
      }

      return true
    })
  }, [detalles, filtroProducto, filtroOficinaId, nombreOficinaSeleccionada])

  const filasConFiltro = React.useMemo(() => {
    return [{ __isFilterRow: true, _idFila: '__filter__' }, ...detallesFiltrados]
  }, [detallesFiltrados])

  return (
    <Table
      containerId='detalles-requerimientos'
      filas={filasConFiltro}
      headRows={[
        { label: 'USUARIO' },
        { label: 'PRODUCTO' },
        { label: 'OFICINA SOL.' },
        { label: 'CANT.' },
        { label: 'U. MED' },
        { label: 'PRECIO' },
        { label: 'ALMACEN' },
        { label: 'O. COMPRA' }
      ]}
      maxRowsShown={20}
      rowTemplate={row => {
        if (row.__isFilterRow) {
          return (
            <Table.Row key={row._idFila}>
              <Table.Cell />
              <Table.Cell>
                <input
                  id='filtro-producto'
                  type='text'
                  className='form-control form-control-sm'
                  placeholder='Buscar producto...'
                  value={filtroProducto}
                  onChange={e => setFiltroProducto(e.target.value)}
                  autoComplete='off'
                />
              </Table.Cell>
              <Table.Cell>
                <Form.Select
                  id='filtro-oficina'
                  value={filtroOficinaId}
                  onChange={e => setFiltroOficinaId(e.target.value)}
                >
                  <option value=''>Seleccionar</option>
                  {oficinas.map(x => (
                    <option key={x._id} value={x._id}>
                      {x.nombre}
                    </option>
                  ))}
                </Form.Select>
              </Table.Cell>
              <Table.Cell />
              <Table.Cell />
              <Table.Cell />
              <Table.Cell />
              <Table.Cell />
            </Table.Row>
          )
        }

        return <Rows.MainRow key={row._idFila} row={row} dispatch={dispatch} />
      }}
    />
  )
}

export default React.memo(DetallesTable)
